import React from 'react';
import './Header.css';

const Header = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'home', label: 'About' }, // Mapped 'home' ID to 'About' label to keep routing simple
    { id: 'experience', label: 'Experience' },
    { id: 'projects', label: 'Projects' },
    { id: 'coffee', label: 'Coffee' },
    { id: 'contact', label: 'Contact' },
  ];

  return (
    <header className="header">
      <div className="logo-container">
        <h1 className="logo-text">Atri Vyas</h1>
      </div>
      <nav className="nav-links">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`nav-item ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </nav>
    </header>
  );
};

export default Header;